import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { DriveAnim, FirmwareAnim, SetupAnim } from "./StepAnimations";

const STEPS = [
  { n: "01", t: "Install Pybricks firmware", d: "Once per hub. Five minutes with a USB cable, free from code.pybricks.com, and you can switch back any time.", to: "/firmware", Anim: FirmwareAnim },
  { n: "02", t: "Choose drivetrain + motors", d: "Pick how your robot is built and which ports its motors are plugged into.", to: "/try", Anim: SetupAnim },
  { n: "03", t: "Map the controller & drive!", d: "Choose your sticks and buttons, press Drive, and the hub pairs straight to the controller.", to: "/classroom", Anim: DriveAnim },
];

const delays = ["delay-2", "delay-3", "delay-4"];

export const HeroSteps = () => (
  <div className="mt-14" data-testid="hero-steps">
    <p className="eyebrow fade-up delay-2 text-muted-foreground">Three steps to driving</p>
    <div className="mt-4 grid gap-5 md:grid-cols-3">
      {STEPS.map(({ n, t, d, to, Anim }, i) => (
        <div key={n} className={`fade-up ${delays[i]}`}>
          <Link to={to} className="lift group block h-full rounded-3xl border bg-card p-3 shadow-xl shadow-primary/5" data-testid={`step-${n}`}>
            <Anim />
            <div className="px-3 pb-3 pt-5">
              <div className="flex items-baseline gap-3">
                <span className="font-display text-3xl font-black text-primary/30 transition-colors group-hover:text-primary">{n}</span>
                <h3 className="text-lg font-bold">{t}</h3>
                <ArrowUpRight className="ml-auto h-4 w-4 shrink-0 self-center text-muted-foreground transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-primary" />
              </div>
              <p className="mt-2 text-sm text-muted-foreground">{d}</p>
            </div>
          </Link>
        </div>
      ))}
    </div>
  </div>
);
